import { NotificationData, RecruitmentAlertResource } from './types';

/** The pair a RECRUITMENT_CELL_CRITICAL alert points at (REAL-3273). */
export const alertResource = (
  notification: NotificationData
): RecruitmentAlertResource | null =>
  (notification.resource as RecruitmentAlertResource | null | undefined) ??
  null;
